// A1	问卷
// A2	本题为必答题，请作答
// A3	本题至少要选择{num}个答案
// A4	本题最多可选择{num}个答案
// A5	请在其他选项后填写内容
// A6	不少于{num}字
// A7	作答字数不足
// A8	超出最大限制文字数
// A9	{num}星
// A10	中立
// A11	感谢您的填写，我们为您准备了一份小礼物
// A12	上一题
// A13	下一题
// A14	第{num}题
// A15	您已领取奖励，点击退出返回游戏。
// A16	退出
export default {
  A1() {
    return 'Khảo sát'
  },
  A2() {
    return 'Câu hỏi bắt buộc, hãy trả lời'
  },
  A3(num: number) {
    return `Phải chọn ít nhất ${num} câu trả lời cho câu hỏi này`
  },
  A4(num: number) {
    return `Có thể chọn tối đa ${num} câu trả lời cho câu hỏi này`
  },
  A5() {
    return `Vui lòng điền nội dung vào lựa chọn Khác`
  },
  A6(num: number) {
    return ` Ít nhất ${num} ký tự`
  },
  A7() {
    return `Câu trả lời không đủ số từ`
  },
  A8() {
    return `Vượt quá giới hạn ký tự tối đa`
  },
  A9(num: number) {
    return `${num}sao`
  },
  A10() {
    return `Trung lập`
  },
  A11() {
    return `Cảm ơn bạn đã hoàn thành khảo sát. Nền tảng đã chuẩn bị một món quà nhỏ tặng bạn.`
  },
  A12() {
    return `Câu hỏi trước`
  },
  A13() {
    return `Câu hỏi tiếp theo`
  },
  A14(num: number) {
    return `Câu số ${num}`
  },
  A15() {
    return `Bạn đã nhận phần thưởng, nhấp vào Thoát để quay lại trò chơi.`
  },
  A16() {
    return `Thoát`
  },
  A17() {
    return `Khác`
  },
  A20() {
    return `Xác nhận`
  },
  A21() {
    return `Hủy`
  },
  A25() {
    return `Xin vui lòng nhập`
  },
  B(key: keyof ReturnType<typeof getInfomationMap>) {
    return getInfomationMap()[key]
  },
  A26() {
    return 'Hoạt động đã hết hạn'
  },
}

function getInfomationMap() {
  return {
    gender: 'Giới tính',
    age: 'Tuổi',
    degree: 'Học vị',
    city: 'Thành phố',
    career: 'Nghề nghiệp',
    income: 'Thu nhập',
    interest: 'Sở thích',
    marital_status: 'Tình trạng hôn nhân',
    family_members: 'Thành viên gia đình',
    personality: 'Tính cách',
    faith: 'Tôn giáo ',
    real_name: 'Họ tên',
    phone: 'Số điện thoại ',
    email: 'Email',
    sport: 'Thể thao',
    book: 'Sách',
    movie: 'Phim',
    music: 'Nhạc',
    star: 'Thần tượng',
    interest_city: 'Thành phố yêu thích',
    interest_country: 'Quốc gia yêu thích',
    color: 'Màu sắc yêu thích',
    season: 'Mùa',
    plant: 'Thực vật',
    animal: 'Động vật',
  }
}
